import { Selector } from 'react-redux';
import { RootState } from '../../redux/root-reducer';
import { IContestManageResponse } from '../../redux/contest/types';
import { createSelector } from 'reselect';

interface IManagedCampaign {
    managedContest?: IContestManageResponse;
    managedContestLoading?: boolean;
    managedContestError?: any;
    updatingContest?: boolean;
}

export const managedCampaignSelector: Selector<RootState, IManagedCampaign> = createSelector(
    (state: RootState) => state.contest,
    contest => ({
        managedContest: contest.managedContest,
        managedContestLoading: contest.managedContestLoading,
        managedContestError: contest.managedContestError,
        updatingContest: contest.creatingContest,
    }),
);
